import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as BronzeBadge } from '../../../../assets/images/BronzeBadge.svg';
import { ReactComponent as GoldBadge } from '../../../../assets/images/GoldBadge.svg';
import { ReactComponent as SilverBadge } from '../../../../assets/images/SilverBadge.svg';

export const LeaderboardItem = ({ item, rank, currentUserId }) => {
  const { t } = useTranslation('dashboard');
  const getRankDisplay = (position) => {
    if (position === 1) {
      return <GoldBadge />;
    }
    if (position === 2) {
      return <SilverBadge />;
    }
    if (position === 3) {
      return <BronzeBadge />;
    }
    return (
      <span
        className={`w-6 h-6 rounded-full ${
          item?.user?.id === currentUserId ? 'bg-gray-200' : 'bg-gray-100'
        } flex items-center justify-center text-gray-700 text-xs font-medium`}
      >
        {position}
      </span>
    );
  };

  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 rounded-xl border ${
        item?.user?.id === currentUserId ? 'bg-gray-100 border-black' : 'border-gray-50 bg-gray-50'
      } transition-colors`}
    >
      <div className="flex-shrink-0 w-6">{getRankDisplay(rank)}</div>
      <div className="relative flex-shrink-0">
        <img src={item?.user?.avatar_thumb} alt={item?.user?.full_name} className="w-8 h-8 rounded-full object-cover" />
      </div>
      <div className="flex items-center justify-between w-full min-w-0">
        <p className="text-sm font-medium text-gray-600 truncate mb-0">
          {item?.user?.id === currentUserId ? t('leaderboard.you') : item?.user?.full_name}
        </p>
        <p className="text-sm font-medium text-gray-600 flex-shrink-0 mb-0">{item?.referrals_sent}</p>
      </div>
    </div>
  );
};
